export const TextFormatAlign = {
    CENTER: "center",
    END: "end",
    JUSTIFY: "justify",
    LEFT: "left",
    RIGHT: "right",
    START: "start"
};
